// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NHsC","colBig":"styles_colBig__3Ii8B","colSmall":"styles_colSmall__eUCEa"};